import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form", {
    attrs: {
      layout: "inline",
      form: _vm.form,
      labelAlign: "left"
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("合同编号")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("合同编号"),
      allowClear: ""
    },
    model: {
      value: _vm.form.contractNo,
      callback: function ($$v) {
        _vm.$set(_vm.form, "contractNo", $$v);
      },
      expression: "form.contractNo"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("合同类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("合同类型"),
      allowClear: ""
    },
    model: {
      value: _vm.form.type,
      callback: function ($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, _vm._l(_vm.typeList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("合作方")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("合作方"),
      allowClear: ""
    },
    model: {
      value: _vm.form.partner,
      callback: function ($$v) {
        _vm.$set(_vm.form, "partner", $$v);
      },
      expression: "form.partner"
    }
  })], 1)], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("合同状态")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("合同状态"),
      allowClear: ""
    },
    model: {
      value: _vm.form.status,
      callback: function ($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  }, _vm._l(_vm.statusList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: "8"
    }
  }, [_c("a-form-item", [_c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "primary",
      "html-type": "submit"
    },
    on: {
      click: _vm.searchFun
    }
  }, [_vm._v(_vm._s(_vm.$t("查询")))]), _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "edit"
    },
    on: {
      click: function ($event) {
        ;
        _vm.form = {}, _vm.searchFun();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("重置")))]), _vm.isAuth("customer.contractStore") ? _c("a-button", {
    staticClass: "marginR15",
    attrs: {
      type: "add"
    },
    on: {
      click: function ($event) {
        return _vm.$router.push({
          name: "contractCustomer",
          params: {
            id: -1,
            type: -1
          }
        });
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))]) : _vm._e()], 1)], 1)], 1)], 1), _c("a-table", {
    staticClass: "marginT20",
    attrs: {
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.data,
      align: "center",
      pagination: _vm.pagination,
      rowKey: "id"
    },
    on: {
      change: _vm.handleStandardTableChange
    },
    scopedSlots: _vm._u([{
      key: "index",
      fn: function (text, record, index) {
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "statusName",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(_vm.$t(text)) + " ")];
      }
    }, {
      key: "typeName",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(_vm.$t(text)) + " ")];
      }
    }, {
      key: "action",
      fn: function (text, record) {
        return [_vm.isAuth("customer.contractDetail") ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "contractCustomer",
                params: {
                  id: record.contractId,
                  type: 1
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("查看")))]) : _vm._e(), _vm.isAuth("customer.contractEdit") && record.status != 2 ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "edit",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.$router.push({
                name: "contractCustomer",
                params: {
                  id: record.contractId,
                  type: 2
                }
              });
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.isAuth("customer.contractStop") && record.status == 1 ? _c("a-button", {
          staticClass: "marginR15",
          attrs: {
            type: "primary",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.suspensionFun(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("中止")))]) : _vm._e(), _vm.isAuth("customer.contractDelete") ? _c("a-button", {
          attrs: {
            type: "danger",
            size: "small"
          },
          on: {
            click: function ($event) {
              return _vm.handleDelete(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.suspensionShow ? _c("suspension-model", {
    ref: "suspensionForm",
    on: {
      cancel: function ($event) {
        _vm.suspensionShow = false;
      },
      ok: _vm.getDataFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };